module.exports = __webpack_public_path__ + "static/media/metier.3ebace2c.svg";